import './../app/shared/operators';

import { of } from 'rxjs/observable/of';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Action} from '@ngrx/store';
import { Effect, Actions } from '@ngrx/effects';

import * as r from '../actions/regions.actions';
import { Api } from '../providers/api/api';

@Injectable()
export class RegionsEffects {
  constructor(private actions$: Actions,
    private api: Api,
  ) {
  }

  @Effect()
  fetchFilters$: Observable<Action> = this.actions$
    .ofType(r.FETCH_REGIONS)
    .map((action: r.FetchRegions) => {
      return action;
    })
    .switchMap((payload) => this.api.fetchRegions())
    .map(regions => {
      return new r.FetchRegionsSuccess(regions);
    }).catch((err) => of(new r.FetchRegionsFailure(err)));

}





// WEBPACK FOOTER //
// ./src/effects/regions.effects.ts